var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 92.109,
    viewBox: "0 0 88 92.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-4{fill:#22b560}.cls-5{fill:none;stroke:#0c65a7;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Package_-_02",
    "data-name": "Package - 02",
    transform: "translate(0 1.109)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_903",
    cx: 44,
    cy: 44.121,
    fill: "#f0f0f0",
    "data-name": "Ellipse 903",
    rx: 44,
    ry: 44.121,
    transform: "translate(0 2.758)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3894",
    "data-name": "Group 3894",
    transform: "translate(15.216 31.485)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1996",
    width: 15.523,
    height: 32.661,
    fill: "#ffc001",
    "data-name": "Rectangle 1996",
    rx: 7.761,
    transform: "translate(21.023 10.462)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1997",
    width: 15.523,
    height: 20.765,
    className: "cls-4",
    "data-name": "Rectangle 1997",
    rx: 7.761,
    transform: "translate(0 22.358)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1998",
    width: 15.523,
    height: 43.123,
    className: "cls-4",
    "data-name": "Rectangle 1998",
    rx: 7.761,
    transform: "rotate(180 28.784 21.561)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3912",
    "data-name": "Group 3912",
    transform: "translate(7.921 2.201)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6418",
    d: "M234.208 177.4l33.771-23.688 7.693 9.3 31.479-23.332",
    className: "cls-5",
    "data-name": "Path 6418",
    transform: "translate(-234.208 -135.431)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6419",
    d: "M666.512 108.887l13.981 1.534-1.617 13.256",
    className: "cls-5",
    "data-name": "Path 6419",
    transform: "translate(-603.648 -108.887)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage02);
export default __webpack_public_path__ + "static/media/package-02.fb8411eb132c89610e99b57a2a56908a.svg";
export { ForwardRef as ReactComponent };